import {ChangeDetectionStrategy, Component, HostListener, Input} from '@angular/core';
import {Router} from "@angular/router";

import {SimpleDialect} from "../../models/dialect.model";
import {GetRegion2Css, GetRegion2Name} from "../../defines/client.const";
import {multiLinkMixin} from "../../mixins/multi-link.mixin";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";

@Component({
  selector: 'app-other-region-dialect',
  template: `
    <div class="other-wrap">
      <a class="other-btn-box">
        <div class="top-box">{{ dialect.word }}</div>
        <div class="bottom-box type-{{ GetRegion2Css(dialect.area1 ) }}">{{ GetRegion2Name(dialect.area1) }}</div>
      </a>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtherRegionDialectComponent extends multiLinkMixin {
  @Input() dialect?: SimpleDialect;

  public readonly GetRegion2Css = GetRegion2Css;
  public readonly GetRegion2Name = GetRegion2Name;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (this.dialect) {
      const ids = ';' + this.dialect.id;
      this.OpenMultiLink(ids).subscribe(resultLinkPopup => {
        console.warn('OtherRegionDialectComponent.onClick() resultLinkPopup =', resultLinkPopup);
      });
    }
  }
}
